// Client-side storage for the app-level trusted-device token. The server issues
// this once at /devices/verify/confirm; we send it back as the X-Device-Token
// header on every request (see lib/api.ts). It is not a credential on its own —
// a valid Auth0 access token is still required — it only attests "this device
// was verified."

const KEY = 'pv_device_token';

export function getDeviceToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setDeviceToken(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* storage unavailable (private mode / quota) — verification will re-prompt */
  }
}

export function clearDeviceToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
